var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReferencesIco = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 41,
  height: 40,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 20.039,
  cy: 20,
  r: 20,
  fill: "#FFF09F"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M28 10H13a2 2 0 0 0-2 2v3H9v2h2v2H9v2h2v2H9v2h2v3a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1m-8 2.999c1.648 0 3 1.351 3 3A3.01 3.01 0 0 1 20 19c-1.647 0-3-1.353-3-3.001 0-1.649 1.353-3 3-3M26 26H14v-.75c0-2.219 2.705-4.5 6-4.5s6 2.281 6 4.5z"
})));
export default SvgReferencesIco;